import { ServiceBase } from './ServiceBase'

export class RemoteWork extends ServiceBase {}
